import { setCustomScrollStatusAction } from "../../_store/customScrollStatus";
import { buildEffectWithElementHook } from "../../_shared/elementForFeatureHook";

export const useHorizontalNegativeScrollAdjustment = buildEffectWithElementHook(
    (element, { dispatch }) => {
        const originalScrollLeft = element.scrollLeft;
        element.scrollLeft = -1;
        const isNegativeScroll = element.scrollLeft < 0;
        element.scrollLeft = originalScrollLeft;

        const negativeScrollAdjustment = isNegativeScroll
            ? element.scrollWidth - element.clientWidth
            : 0;

        dispatch(setCustomScrollStatusAction({ negativeScrollAdjustment }));
    }
);
